import { Component, OnInit, Input } from '@angular/core';
import { TipoPagoService } from '../../../../providers/tipo-pago.service';
import { PageEvent, Sort, MatTableDataSource } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { TipoPago } from '../../../../interfaces/tipo-pago';
import { PermisoService } from '../../../../providers/permiso.service';

@Component({
  selector: 'app-ver-tipos-pago',
  templateUrl: './ver-tipos-pago.component.html',
  styleUrls: ['./ver-tipos-pago.component.scss']
})
export class VerTiposPagoComponent implements OnInit {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaTiposPagoColumnas = ['descripcion'];
  tiposPagoDataSource = new MatTableDataSource();
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtro: string = '';
  getTiposPagoSuscripcion = new Subscription();
  tipoPagoCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las pagos

  constructor(
    private tiposIndicenciaService: TipoPagoService,
    private permisoService: PermisoService
  ) {
    // pregunta si tiene permisos (retorna true o false)
    // si los permisos aún no estan cargados se queda preguntando hasta que esten cargados
    this.permisoService.tienePermiso('TIPO-PAGO-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaTiposPagoColumnas.push('acciones');
      }
    });
  }

  ngOnInit() {
    // set valores iniciales
    this.sort.active = 'descripcion';
    this.sort.direction = 'asc';
    this.page.pageIndex = 0;
    this.page.pageSize = +localStorage.getItem('itemsPorPagina') || 10;
    this.page.length = 0;
    this.actualizarTabla();
  }

  onFiltro(filterValue: string) {
    this.page.pageIndex = 0;
    this.filtro = filterValue.trim().toLowerCase();
    this.actualizarTabla();
  }

  sortData(sort: Sort) {
    this.page.pageIndex = 0;
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('itemsPorPagina', pageEvent.pageSize.toString()); // los items por pagina se recuerdan
    this.page = pageEvent;
    this.actualizarTabla();
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getTiposPagoSuscripcion && !this.getTiposPagoSuscripcion.closed) {
        this.getTiposPagoSuscripcion.unsubscribe();
      }

      var filtros: any = { // array de filtros internos
        generico: this.filtro
      };

      this.getTiposPagoSuscripcion = this.tiposIndicenciaService
        .getTiposPago(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(filtros, this.filtrosExternos) // filtros del componente mas los filtros según donde se muestra el componente
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.tipoPagoCount = respuesta.data.total;
              }

              var tiposPago: TipoPago[] = []; // array de datos obtenidos
              if (respuesta.data.pagos) {
                respuesta.data.pagos.forEach(tipoPago => {
                  tiposPago.push(<TipoPago>{
                    id: tipoPago.id,
                    descripcion: tipoPago.descripcion
                  });
                });
              }

              this.tiposPagoDataSource.data = tiposPago;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
    if (this.getTiposPagoSuscripcion && !this.getTiposPagoSuscripcion.closed) {
      this.getTiposPagoSuscripcion.unsubscribe();
    }
  }
}
